import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { jsx } from "slate-hyperscript";
import Avatar from "../../avatar/Avatar";
import Styles from "../Editor.module.scss";
import {
    BlockDeserializer, ElementRenderer,
    ElementSettings, InlineHandler, StyleType, TextElement,
} from "./base";

export interface MentionSettings extends ElementSettings {
    id?: string;
    name?: string;
    avatarUrl?: string
}

InlineHandler.register(StyleType.MENTION, {
    nodeTypes: ["MENTION"],
    toBlock: (child, settings, editorSettings) => (
        <span
            data-id={settings.id}
            data-type="mention"
            className={`alert alert-secondary p-1 ${Styles.mention}`}
            contentEditable={false}
        >
            <Avatar src={settings.avatarUrl} variant="xs" className="me-1" />
            {child}
            {/* {!editorSettings.isReadOnly && (

                <button
                    className="btn btn-sm btn-none text-gray-800 btn-sm ms-1 p-0 align-baseline"
                    type="button"
                    onClick={editorSettings.onRemove}
                >
                    <AiOutlineClose />
                </button>

            )} */}
        </span>
    ),
    serialize: (child, settings) => `<mention data-id="${settings.id}" data-name="${settings.name}">@${settings.name}</mention>`,
    deserialize: children => jsx("element", { ...children, [StyleType.MENTION]: Object.create(null) }),
    apply: () => ({
        userId: "",
        name: "",
        avatarUrl: "",
    }),
} as ElementRenderer<MentionSettings> & BlockDeserializer<TextElement>);
